import { useQuery } from "@tanstack/react-query";
import { institute } from "./query";
import { IInstituteGridFilter } from "./types";
import { PostModel } from "common/models/BaseModel";

export function GetInstitutes(
  model: PostModel<IInstituteGridFilter> | undefined
) {
  return useQuery(institute.list(model));
}

export function GetInstitute(Id: string | number) {
  return useQuery({
    ...institute.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetInstituteValues() {
  return useQuery(institute.getInstituteValues());
}

export function GetInstituteView(id: string | number, isOpen: boolean) {
  return useQuery({
    ...institute.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}

export function GetInstituteByUniverisity(Id: string | number) {
  return useQuery({
    ...institute.getInstituteByUniverisity(Id),
    enabled: Boolean(Id),
  });
}

export function GetInstituteByLibrary() {
  return useQuery({
    ...institute.getInstituteByLibrary(),
  });
}
